export const logoHeader = process.env.REACT_APP_LOGO_HEADER
export const loginBackground = process.env.REACT_APP_LOGIN_BG